import { api } from '@/lib/api'
import { deviceHeaders, type Canal, type VerificationState } from '@/lib/verificationConnexion'

/** GET /api/connexion/verification/ : channel, last digits of the phone, other methods. */
export async function fetchVerification(): Promise<VerificationState> {
  // A unique query string: a browser that kept an old "expired" answer
  // (Safari, 28 Oct 2026) must ask the server again, never reuse it.
  const { data } = await api.get<VerificationState>('/api/connexion/verification/', {
    params: { t: Date.now() },
  })
  return data
}

/** POST /api/connexion/verification/envoyer/ : new code by text, voice call or email. */
export async function sendVerificationCode(canal: Canal): Promise<VerificationState> {
  const { data } = await api.post<VerificationState>('/api/connexion/verification/envoyer/', { canal })
  return data
}

/** POST /api/connexion/verification/verifier/ : fresh tokens without the mark. */
export async function confirmVerificationCode(
  code: string,
  remember: boolean,
): Promise<{ access: string; refresh: string }> {
  const { data } = await api.post<{ access: string; refresh: string }>(
    '/api/connexion/verification/verifier/',
    { code, se_souvenir: remember },
    { headers: deviceHeaders() },
  )
  return data
}
